import { KpiCard, HorizontalBarChart, AreaLineChart, VerticalBarChart, DonutChart, Chip } from '@/components/ui'
import { TrendingUp, Target, BookOpen, AlertCircle } from 'lucide-react'

export function Aprendizaje() {
  const intentsTop = [
    { label: 'consultar_saldo', value: 142, total: 316, color: '#10b981', icon: '💰' },
    { label: 'ver_cuentas_pago', value: 86, total: 316, color: '#3b82f6', icon: '🏦' },
    { label: 'enviar_comprobante', value: 42, total: 316, color: '#f59e0b', icon: '📄' },
    { label: 'detalle_credito', value: 28, total: 316, color: '#8b5cf6', icon: '🧾' },
    { label: 'ayuda_humano', value: 18, total: 316, color: '#f43f5e', icon: '🙋' },
  ]

  const kbUtilizadas = [
    { label: 'manual-cuentas-point.md', value: 68, total: 100, color: '#3b82f6' },
    { label: 'FAQ-cobranza-v3.pdf', value: 54, total: 100, color: '#10b981' },
    { label: 'politica-descuentos-2026.pdf', value: 22, total: 100, color: '#f59e0b' },
    { label: 'razones-sociales.xlsx', value: 18, total: 100, color: '#8b5cf6' },
    { label: 'instructivo-comprobantes.md', value: 9, total: 100, color: '#f43f5e' },
  ]

  const serie = [8, 12, 18, 22, 28, 35, 42, 38, 44, 52, 48, 55, 62, 58]
  const dias = ['L', 'M', 'X', 'J', 'V', 'S', 'D', 'L', 'M', 'X', 'J', 'V', 'S', 'D']

  const nuevosIntents = [
    { intent: 'solicitar_cronograma_pagos', ejemplos: 7, estado: 'pending' },
    { intent: 'reclamo_cuenta_pagada', ejemplos: 4, estado: 'pending' },
    { intent: 'cambio_fecha_corte', ejemplos: 3, estado: 'review' },
  ]

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KpiCard label="Precisión intent" value="94.1%" sub="últimos 7d" icon={<Target className="w-3.5 h-3.5" />} color="emerald" />
        <KpiCard label="Hit-rate KB" value="86%" sub="docs recuperados" icon={<BookOpen className="w-3.5 h-3.5" />} />
        <KpiCard label="Nuevos intents detectados" value="3" sub="pendientes revisar" icon={<TrendingUp className="w-3.5 h-3.5" />} color="amber" />
        <KpiCard label="Mensajes sin match" value="12" sub="4% del total" icon={<AlertCircle className="w-3.5 h-3.5" />} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <section className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-5">
          <header className="flex items-center justify-between mb-4">
            <div>
              <h2 className="font-display text-lg text-navy-700">Intents más frecuentes · últimos 7 días</h2>
              <p className="text-xs text-slate-500">Top 5 — total 316 mensajes</p>
            </div>
          </header>
          <HorizontalBarChart items={intentsTop} />
        </section>

        <section className="bg-white border border-slate-200 rounded-xl p-5 flex flex-col items-center justify-center">
          <h2 className="font-display text-lg text-navy-700 mb-3">Distribución canal de resolución</h2>
          <DonutChart
            size={180}
            segments={[
              { label: 'Bot', value: 90, color: '#10b981' },
              { label: 'Humano', value: 8, color: '#f59e0b' },
              { label: 'Sin resolver', value: 2, color: '#f43f5e' },
            ]}
            centerValue="90%"
            centerLabel="Auto bot"
          />
          <ul className="mt-4 text-xs space-y-1">
            <LegendItem color="#10b981" label="Bot resolvió" value="284 (90%)" />
            <LegendItem color="#f59e0b" label="Humano intervino" value="26 (8%)" />
            <LegendItem color="#f43f5e" label="Sin resolver" value="6 (2%)" />
          </ul>
        </section>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <section className="bg-white border border-slate-200 rounded-xl p-5">
          <header className="mb-3">
            <h2 className="font-display text-lg text-navy-700">Volumen diario · últimos 14d</h2>
            <p className="text-xs text-slate-500">Mensajes IN atendidos por el copilot</p>
          </header>
          <AreaLineChart values={serie} color="#10b981" height={180} />
          <div className="flex justify-between mt-1 text-[10px] text-slate-500 font-mono">
            {dias.map((d, i) => <span key={i}>{d}</span>)}
          </div>
        </section>

        <section className="bg-white border border-slate-200 rounded-xl p-5">
          <header className="mb-3">
            <h2 className="font-display text-lg text-navy-700">Documentos KB más utilizados</h2>
            <p className="text-xs text-slate-500">% de respuestas que citaron cada doc</p>
          </header>
          <HorizontalBarChart items={kbUtilizadas} showPercent={false} />
        </section>
      </div>

      <section className="bg-white border border-slate-200 rounded-xl p-5">
        <header className="mb-3">
          <h2 className="font-display text-lg text-navy-700">Intents nuevos detectados</h2>
          <p className="text-xs text-slate-500">El copilot encontró patrones recurrentes no clasificados. Revisá y promoveles si corresponden.</p>
        </header>
        <div className="space-y-2">
          {nuevosIntents.map(it => (
            <div key={it.intent} className="flex items-center justify-between gap-3 bg-slate-50 rounded-lg px-4 py-3">
              <div>
                <div className="font-mono font-semibold text-navy-700 text-sm">{it.intent}</div>
                <div className="text-xs text-slate-500 mt-0.5">{it.ejemplos} mensajes similares detectados · aún sin ruta de respuesta</div>
              </div>
              <div className="flex items-center gap-2">
                <Chip variant={it.estado === 'pending' ? 'amber' : 'blue'}>{it.estado === 'pending' ? 'Pendiente' : 'En revisión'}</Chip>
                <button className="px-3 py-1 text-xs rounded-md bg-navy-700 text-white hover:bg-navy-600">Revisar ejemplos</button>
                <button className="px-3 py-1 text-xs rounded-md bg-emerald-600 text-white hover:bg-emerald-700">Promover a intent</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white border border-slate-200 rounded-xl p-5">
        <header className="mb-3">
          <h2 className="font-display text-lg text-navy-700">Horas pico (lunes a viernes)</h2>
          <p className="text-xs text-slate-500">Mensajes atendidos por hora del día — promedio</p>
        </header>
        <VerticalBarChart
          values={[2, 1, 1, 0, 1, 3, 6, 12, 24, 32, 38, 42, 28, 18, 32, 44, 48, 36, 22, 14, 10, 7, 5, 3]}
          labels={['00','','','03','','','06','','','09','','','12','','','15','','','18','','','21','','']}
          color="#10b981"
          height={160}
        />
      </section>
    </div>
  )
}

function LegendItem({ color, label, value }: { color: string; label: string; value: string }) {
  return (
    <li className="flex items-center gap-2 text-slate-700">
      <span className="w-3 h-3 rounded-sm" style={{ background: color }} />
      <span className="flex-1">{label}</span>
      <span className="font-mono text-slate-500">{value}</span>
    </li>
  )
}
